/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

import MKTypography from "components/MKTypography";

// Material Kit 2 React examples

import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes

import footerRoutes from "footer.routes";

// Image
import bgImage from "assets/signup.jpg";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MKButton from "components/MKButton";
import Icon from "@mui/material/Icon";
import { SiMicrosoftoutlook, SiGmail } from "react-icons/si";
import { Chip, Divider } from "@mui/material";

function VerificationEmail() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("verificationEmailSent")) {
      navigate("/sign-up");
    }
  }, []);
  return (
    <>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} lg={6}>
          <MKBox
            display={{ xs: "none", lg: "flex" }}
            width="calc(100% - 2rem)"
            height="calc(100vh - 2rem)"
            borderRadius="lg"
            ml={2}
            mt={2}
            sx={{ backgroundImage: `url(${bgImage})` }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={10}
          md={7}
          lg={6}
          xl={4}
          ml={{ xs: "auto", lg: 6 }}
          mr={{ xs: "auto", lg: 6 }}
        >
          <MKBox
            bgColor="white"
            borderRadius="xl"
            shadow="lg"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            mt={{ xs: 20, sm: 18, md: 20 }}
            mb={{ xs: 20, sm: 18, md: 20 }}
            mx={3}
          >
            <MKBox
              variant="gradient"
              bgColor="info"
              coloredShadow="info"
              borderRadius="lg"
              p={2}
              mx={2}
              mt={-3}
            >
              <MKTypography variant="h3" color="white">
                Verify Email
              </MKTypography>
            </MKBox>
            <MKBox p={3}>
              <MKTypography variant="body2" color="text" mb={3}>
                An email has been sent containing the verification link. Please click on the email
                to verify your link
              </MKTypography>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <MKButton
                  onClick={() => window.open("https://gmail.com", "_blank")}
                  variant="gradient"
                  color="info"
                  style={{ marginRight: "1rem" }}
                >
                  <SiGmail></SiGmail>&nbsp; Gmail
                </MKButton>

                <MKButton
                  onClick={() => window.open("https://outlook.com", "_blank")}
                  variant="gradient"
                  color="info"
                >
                  <SiMicrosoftoutlook></SiMicrosoftoutlook>&nbsp; Outlook
                </MKButton>
              </div>
              <Divider></Divider>

              <div
                onClick={() => navigate("/sign-in")}
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                <MKTypography variant="body2"> Back to Login - </MKTypography>
                <MKButton
                  type="button"
                  variant="text"
                  color="info"
                  sx={{ paddingLeft: "0.5rem", marginTop: "0.2rem" }}
                >
                  SIGN IN
                </MKButton>
              </div>
            </MKBox>
          </MKBox>
        </Grid>
      </Grid>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default VerificationEmail;
